import React from "react";
import { Body, Heading, HeadingBorder } from "../../atoms";
import { Section } from "../../molecules";
export var SimpleContent = function(param) {
    var title = param.title, children = param.children, className = param.className, enableLines = param.enableLines;
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 gap-6 md:grid-cols-2"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(HeadingBorder, null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h3"
    }, title))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        className: "prose md:prose-md"
    }, children))));
};

//# sourceMappingURL=SimpleContent.js.map